import './App.css';
import { initTranslations } from './core';
import de from './translations/de.json';
import fr from './translations/fr.json';
import en from './translations/en.json';
import zh from './translations/zh.json';
import ja from './translations/ja.json';
import it from './translations/it.json';
import ur from './translations/ur.json';

import './styles/index.scss';
import { ZakekeEnvironment, ZakekeProvider } from 'zakeke-configurator-react';
import Viewer from './pages/Viewer';

initTranslations({
  defaultLanguage: 'it',
  translations: { en, it, de, fr, zh, ja, ur },
});

const zakekeEnvironment = new ZakekeEnvironment();

function App() {
  return (
    <ZakekeProvider environment={zakekeEnvironment}>
      <Viewer />
    </ZakekeProvider>
  );
}

export default App;

/* 
NOTE for ROUTING: 
If you want to use multiple routes lets use:
return ( 
  <Router>
    <Routes/>
  </Router> 
)
Find Routes example in /src/routes/routes.tsx
*/
